<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Wj3OeA/cover.jpeg?1684229397020" alt="This image is the cover for the book Soldier King of Life, Volume 33"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Soldier King of Life, Volume 33
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>Mercenary King Chen Qingyang returned to the city to protect his comrade's sister.</strong> </p><p>the goddess. In the bustling city, Chen Qingyang was like a fish in water, carefree and at ease. And to see how the previous generation's soldiers would use their iron fists and wits to build a business empire...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wo ZiDuiTianXiao, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a19c3ee8